var _clipPath, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 250 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 25
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 150,
    fill: "#e8112d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(125,75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "r20",
    transform: "scale(0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "r4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "r1",
    fill: "#ffef00",
    d: "m-8.4,108c8.4,22 -9.6,56 8.4,72c-6,-24 14-50 8.4,-72s-25.2,-22 -16.8,0z"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(90)",
    xlinkHref: "#r1"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(180)",
    xlinkHref: "#r1"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(270)",
    xlinkHref: "#r1"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(18)",
    xlinkHref: "#r4"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(36)",
    xlinkHref: "#r4"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(54)",
    xlinkHref: "#r4"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(72)",
    xlinkHref: "#r4"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(9)",
    xlinkHref: "#r20"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 27,
    fill: "#e8112d"
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -1.5,
    r: 22.5,
    fill: "#ffef00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "x",
    fill: "#e8112d",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-23.055236,18a37.755236,37.755236 0 1,1 75.510472,0H52.760449a36.260449,36.260449 0 1,0 -72.520898,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.601203,18a35.301203,35.301203 0 1,1 70.602406,0H53.424578a33.924578,33.924578 0 1,0 -67.849156,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7,-15.052356a33.052356,33.052356 0 1,0 0,66.104712L22.5,49.819805a31.819805,31.819805 0 1,1 0,-63.63961z"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "scale(-1,1)",
    xlinkHref: "#x"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKg);
export default __webpack_public_path__ + "static/media/KG.58c44ab0310d07123a0cbf4f819247ef.svg";
export { ForwardRef as ReactComponent };